import React from "react"
import ScrollToTop from "react-scroll-up"
import {Button} from "reactstrap"
import {ArrowUp} from "react-feather"
import classnames from "classnames"

const Footer = props => {
  let footerTypeArr = ["sticky", "static", "hidden"]

  const footerClasses = classnames("footer footer-light", {
    "footer-static": props.footerType === "static" || !footerTypeArr.includes(props.footerType),
    "d-none": props.footerType === "hidden"
  });

  return (
    <footer
      className={footerClasses}
    >
      <p className="mb-0 clearfix">
        <span className="float-md-left d-block d-md-inline-block mt-25">
          COPYRIGHT © {new Date().getFullYear()}
          <a
            href="https://www.skylarksoft.com/"
            target="_blank"
            rel="noopener noreferrer"
          >
            SkylarkSoft,
          </a>
          All rights reserved
        </span>
        <span className="float-md-right d-none d-md-block">
          <span className="align-middle">
            A product of <a href="https://www.skylarksoft.com/" rel="noopener noreferrer" target="_blank">Skylark Soft Limited</a>
          </span>{" "}

        </span>
      </p>
      {props.hideScrollToTop === false ? (
        <ScrollToTop showUnder={160}>
          <Button color="primary" className="btn-icon scroll-top">
            <ArrowUp size={15} />
          </Button>
        </ScrollToTop>
      ) : null}
    </footer>
  )
}

export default Footer
